<!-- opus-six.component.html -->
<div class="opus-six-dialog">
  <!-- Close (consistent X) -->
  <button class="close-btn" (click)="close()" aria-label="Close Claude Opus 4.6 dialog">×</button>

  <!-- Header -->
  <div class="header">
    <!-- swap to your actual logo if you have one -->
    <img src="assets/logos/anthropic.svg" alt="Claude Opus 4.6 logo" class="logo" />

    <h2>Claude&nbsp;Opus&nbsp;4.6</h2>
    <div class="sub">Deep reasoning • High-fidelity writing • Long-context synthesis</div>

    <!-- optional quick chips row -->
    <div class="chips">
      <span class="chip">Best for: complex synthesis</span>
      <span class="chip">Style: premium long-form</span>
      <span class="chip">Strength: rigorous reasoning</span>
    </div>
  </div>

  <!-- Body -->
  <div class="body">
    <p>
      <strong>Claude&nbsp;Opus&nbsp;4.6</strong> is designed for high-stakes, high-clarity work where you want
      careful thinking, strong structure, and polished output. It tends to shine when the prompt
      is complex (many constraints), the context is large (long docs / multiple sources), or the
      deliverable needs to be <strong>decision-ready</strong> (exec summaries, plans, specs, and analysis).
    </p>

    <div class="section">
      <h3>What Claude Opus 4.6 is best at</h3>
      <ul>
        <li><strong>Deep synthesis:</strong> combines multiple ideas, documents, and constraints into one cohesive answer.</li>
        <li><strong>Long-form structure:</strong> produces clear headings, steps, and consistently formatted deliverables.</li>
        <li><strong>High precision writing:</strong> fewer “hand-wavy” statements and stronger internal consistency.</li>
        <li><strong>Planning + decomposition:</strong> breaks down multi-step tasks into executable sequences.</li>
        <li><strong>Executive clarity:</strong> summarizes complexity into crisp outcomes, risks, and next actions.</li>
      </ul>
    </div>

    <div class="section optimal">
      <h3>Reasoning controls</h3>
      <ul>
        <li><strong>Auto:</strong> adapts reasoning depth based on prompt complexity and context size.</li>
        <li><strong>Instant:</strong> fastest responses; use for quick drafts or simple Q&amp;A.</li>
        <li><strong>Thinking:</strong> balanced reasoning; best default for most professional work.</li>
        <li><strong>Pro:</strong> deeper reasoning for high-stakes analysis, architecture decisions, or nuanced tradeoffs.</li>
      </ul>
      <div class="tip">
        <strong>Tip:</strong> If you want the best output, ask for “assumptions + approach + final answer”
        and use <strong>Thinking</strong> or <strong>Pro</strong> when accuracy matters.
      </div>
    </div>

    <div class="section">
      <h3>When Claude Opus 4.6 is optimal</h3>
      <ul>
        <li>Multi-source research, synthesis, and long-context Q&amp;A</li>
        <li>Writing specs, PRDs, technical proposals, and architecture summaries</li>
        <li>Reviewing strategies, policies, compliance language, or risk-heavy decisions</li>
        <li>“Make this clean and shippable” refactors: docs, code explanations, structured output</li>
        <li>Anything that needs polish + correctness + coherent reasoning</li>
      </ul>
    </div>

    <div class="section callout">
      <div class="callout-title">Best vibes use-cases</div>
      <div class="callout-grid">
        <div class="pill">Exec-ready summaries</div>
        <div class="pill">Deep research briefs</div>
        <div class="pill">Architecture / design docs</div>
        <div class="pill">Policy &amp; compliance analysis</div>
        <div class="pill">Technical writing &amp; specs</div>
        <div class="pill">Multi-step plans</div>
      </div>
    </div>

    <div class="section note">
      <strong>Note:</strong> Claude Opus 4.6 performs best when you provide:
      (1) the goal, (2) constraints, (3) context, and (4) the desired output format.
      If you want a specific structure (tables, bullets, JSON), say so explicitly.
    </div>
  </div>
</div>
